export const alchemyMainnetUrl = `https://eth-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_MAINNET_KEY}`;

export const alchemyBaseUrl = `https://base-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_MAINNET_KEY}`;
